import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_271: DocMigration = {
  maxSchemaVersion: "0.0.271",
  description: "Move roof instance start and end truncation to roofSideOverrides",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofSettings = {} } = roof;
      let { roofSideOverrides = {} } = roof;
      const {
        startTruncationType,
        startTruncationHeightFactor,
        startTruncationNormalizedHeight,
        startTruncationSlope,
        startTruncationSlopeType,
        endTruncationType,
        endTruncationHeightFactor,
        endTruncationNormalizedHeight,
        endTruncationSlope,
        endTruncationSlopeType,
      } = roofSettings;

      if (
        startTruncationType !== undefined ||
        startTruncationHeightFactor !== undefined ||
        startTruncationNormalizedHeight !== undefined ||
        startTruncationSlope !== undefined ||
        startTruncationSlopeType !== undefined
      ) {
        roofSideOverrides = {
          ...roofSideOverrides,
          START: {
            ...roofSideOverrides.START,
            truncationType: startTruncationType,
            truncationHeightFactor: startTruncationHeightFactor,
            truncationNormalizedHeight: startTruncationNormalizedHeight,
            truncationSlope: startTruncationSlope,
            truncationSlopeType: startTruncationSlopeType,
          },
        };
      }
      if (
        endTruncationType !== undefined ||
        endTruncationHeightFactor !== undefined ||
        endTruncationNormalizedHeight !== undefined ||
        endTruncationSlope !== undefined ||
        endTruncationSlopeType !== undefined
      ) {
        roofSideOverrides = {
          ...roofSideOverrides,
          END: {
            ...roofSideOverrides.END,
            truncationType: endTruncationType,
            truncationHeightFactor: endTruncationHeightFactor,
            truncationNormalizedHeight: endTruncationNormalizedHeight,
            truncationSlope: endTruncationSlope,
            truncationSlopeType: endTruncationSlopeType,
          },
        };
      }

      delete roofSettings.startTruncationType;
      delete roofSettings.startTruncationHeightFactor;
      delete roofSettings.startTruncationNormalizedHeight;
      delete roofSettings.startTruncationSlope;
      delete roofSettings.startTruncationSlopeType;
      delete roofSettings.endTruncationType;
      delete roofSettings.endTruncationHeightFactor;
      delete roofSettings.endTruncationNormalizedHeight;
      delete roofSettings.endTruncationSlope;
      delete roofSettings.endTruncationSlopeType;

      roofs[id] = {
        ...roof,
        roofSideOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_271;
